import { render } from "./SereneTermsAndConditionsES.vue?vue&type=template&id=1de277d7"
import script from "./SereneTermsAndConditionsES.vue?vue&type=script&lang=js"
export * from "./SereneTermsAndConditionsES.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__